export default __webpack_public_path__ + "static/Smartfinn_logo-83f645137db354d46b8d16c5a15ae8c3.png";